import PropTypes from "prop-types";

import PricingReportQuarterlySummaryCards from "./PricingReportQuarterlySummaryCards";
import PricingReportPrintCards from "./PricingReportPrintCards";
import PricingReportPrintHeader from "./PricingReportPrintHeader";
import PricingReportPrintHtmlText from "./PricingReportPrintHtmlText";
import PricingReportPrintTable from "./PricingReportPrintTable";
import "./design/design.scss";
import "./pricingReportPrint.scss";

function PricingReportPrintChartSections({ sections, descriptionKey = "description" }) {
  if (!sections?.length) return null;

  return (
    <>
      {sections.map((section) => (
        <div key={section.key} className="pricing-report-print-chart-block">
          {section.title ? (
            <PricingReportPrintHtmlText
              html={section.title}
              component="h3"
              className="pricing-report-print-chart-block__title"
            />
          ) : null}
          {section.subtitle ? (
            <PricingReportPrintHtmlText
              html={section.subtitle}
              component="p"
              className="pricing-report-print-chart-block__subtitle"
            />
          ) : null}
          {section[descriptionKey] ? (
            <PricingReportPrintHtmlText
              html={section[descriptionKey]}
              component="p"
              className="pricing-report-print-chart-block__description"
            />
          ) : null}
          {section.imageDataUrl ? (
            <img
              className="pricing-report-print-chart-block__img"
              src={section.imageDataUrl}
              alt={section.title || "Chart"}
            />
          ) : null}
        </div>
      ))}
    </>
  );
}

PricingReportPrintChartSections.propTypes = {
  sections: PropTypes.array,
  descriptionKey: PropTypes.string,
};

export default function PricingReportPrintView({ snapshot }) {
  if (!snapshot) return null;

  const {
    header,
    showQuarterlyKpis,
    quarterlySummaryStats,
    summaryCardSelectedProvince,
    summaryCardSelectedRetailers,
    productSnapshotSections,
    pricingChartSections,
    resultsView,
    table,
    cards,
  } = snapshot;

  return (
    <div
      id="pricing-report-print-root"
      className="pricing-report-print-root"
      aria-hidden="true"
    >
      <div className="pricing-report-print-intro">
        <div className="pricing-report-print-intro__filters">
          <PricingReportPrintHeader header={header} />
        </div>

        {showQuarterlyKpis && quarterlySummaryStats ? (
          <div className="pricing-report-print-intro__summary">
            <div className="pricing-report-print-kpis">
              <PricingReportQuarterlySummaryCards
                quarterlySummaryStats={quarterlySummaryStats}
                isQuarterlySummaryLoading={false}
                selectedProvince={summaryCardSelectedProvince}
                selectedRetailers={summaryCardSelectedRetailers}
              />
            </div>
          </div>
        ) : null}
      </div>

      {productSnapshotSections?.length > 0 ? (
        <PricingReportPrintChartSections sections={productSnapshotSections} />
      ) : null}

      <PricingReportPrintChartSections sections={pricingChartSections} />

      {resultsView === "card" ? (
        <PricingReportPrintCards cards={cards} />
      ) : (
        <PricingReportPrintTable table={table} />
      )}
    </div>
  );
}

PricingReportPrintView.propTypes = {
  snapshot: PropTypes.object,
};
